import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Loader2, ChevronLeft } from "lucide-react";
import { Logo } from "../lib/brand";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background paper-texture px-6">
      <Link to="/" className="absolute top-6 left-6 inline-flex items-center gap-1 text-muted-foreground hover:text-primary text-sm" data-testid="back-home">
        <ChevronLeft size={16} /> Back home
      </Link>
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-card rounded-2xl border border-border p-10 shadow-sm"
      >
        <div className="text-center mb-8">
          <Logo variant="light" className="h-14 w-auto mx-auto" testId="login-logo" />
          <p className="overline mt-3">Admin Console</p>
        </div>
        <div className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              required
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              required
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button
            type="submit"
            data-testid="login-submit-btn"
            disabled={loading}
            className="w-full rounded-full bg-primary hover:bg-primary/90"
          >
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Sign in
          </Button>
        </div>
      </form>
    </div>
  );
}
